var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"breakdance-drag-placeholder-wrapper"},[_c('div',{staticClass:"breakdance-drag-placeholder",style:(_vm.dragPlaceholderPositionStyle)}),_c('div',{staticClass:"breakdance-drag-target-outline",style:(_vm.dragTargetOutlineStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }